import {
  FlexProps,
  Grid,
  GridProps,
  useBreakpointValue
} from '@chakra-ui/react';
import { ReactNode } from 'react';

type ContentProps = {
  children: ReactNode;
} & GridProps &
  FlexProps;

export const Content = ({ children, ...rest }: ContentProps) => {
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  });

  return (
    <Grid
      display={`${isWideVersion ? 'grid' : 'flex'}`}
      templateColumns="repeat(3, 1fr)"
      gap={6}
      flex="1"
      flexDir="column"
      {...rest}
    >
      {children}
    </Grid>
  );
};
